<script>
const echarts = require("echarts");
import { mapActions, mapGetters } from "vuex";
export default {
  name: "police-current",
  data() {
    return {
      loading: true,
      empty: false,
      chart: null,
      messages: [],
      index: 0,
      timer: null,
      group: [],
      groups: [],
      chartData: [],
      queryTimer: null
    };
  },
  async mounted() {
    await this.deviceClass();
    this.queryData();
    this.queryTimer = setInterval(() => {
      this.queryData();
    }, 60 * 1000 * 30);
  },
  computed: {
    ...mapGetters("dataPolice", ["nowData"])
  },
  methods: {
    ...mapActions(["deviceClass"]),
    ...mapActions("dataPolice", ["policeNowMessage"]),
    // 设置图表
    setChart(data) {
      const options = {
        tooltip: {
          trigger: "item",
          position: "right",
          borderRadius: 4,
          formatter: (params) => {
            const name = `<span style="display: inline-block;font-size: 16px; margin-bottom: 8px;">${params.name}</span>`;
            const value = `<span style="margin-left: 17px;font-size: 14px;">现有报警</span> ${params.value}`;
            return `${params.marker}${name}<br />${value}`;
          },
          borderColor: "#a7a7a7",
          borderWidth: 2
        },
        series: [
          {
            type: 'pie',
            radius: ['72%', '84%'],
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: "normal",
                color: "#ffffff",
                formatter: [
                  "{a|{c}}",
                  "{b|现有报警}"
                ].join("\n\n"),
                rich: {
                  a: {
                    color: "#ffffff",
                    fontSize: "22"
                  },
                  b: {
                    color: "#bcb6b2",
                    fontSize: "16"
                  }
                }
              },
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      };
      this.chart.setOption(options);
      window.addEventListener("resize", this.resizeChart);
    },
    resizeChart() {
      this.chart.resize();
    },
    // 获取报警信息
    getAlarmInfo(obj) {
      switch(obj.alarm_status) {
        case 0:
          return `设备（${obj.device.name}）报警解除`;
        case 1:
          return `设备（${obj.device.name}）大于 ${obj.max_value} ${obj.unit} 报警`;
        case 2:
          return `设备（${obj.device.name}）小于 ${obj.min_value} ${obj.unit} 报警`;
      }
      return `设备（${obj.device.name}）状态未知`;
    },
    // 获取传感器信息
    getSensorInfo(id) {
      let name = "";
      let unit = "";
      let color = "";
      for (let i = 0; i < this.$store.state.deviceClass.length; i++) {
        const device = this.$store.state.deviceClass[i];
        if (device.device_data_id === id) {
          name = device.cn_data_name;
          unit = device.unit;
          color = device.pc_color;
          break;
        }
      }
      return {
        name,
        unit,
        color
      };
    },
    createGroups(messages) {
      let groups = [];
      let index = 0;
      let group = [];
      for (let i = 0; i < messages.length; i++) {
        group.push(messages[i]);
        index++;
        if (index === 4 || i === messages.length - 1) {
          index = 0;
          groups.push(group);
          group = [];
        }
      }
      return groups;
    },
    queryData() {
      this.policeNowMessage()
      .then(res => {
        let data = res.data.data;
        this.messages = [];
        this.group = [];
        this.groups = [];
        this.chartData = [];
        clearInterval(this.timer);
        window.removeEventListener("resize", this.resizeChart);
        // 接收数据为空
        if (data.length === 0) {
          this.empty = true;
          return;
        }
        // 统计各种传感器共有多少条报警信息
        const stats = new Map();
        for (let i = 0; i < data.length; i++) {
          // 根据传感器类型 ID 获取名称、单位、颜色
          const { name, unit, color } = this.getSensorInfo(data[i].device_data_id);
          data[i].name = name;
          data[i].unit = unit;
          data[i].color = color;
          // 统计信息
          if (!stats.has(data[i].name)) {
            stats.set(data[i].name, {
              name: data[i].name,
              color: data[i].color,
              count: 1,
            });
          } else {
            const obj = stats.get(data[i].name);
            obj.count++;
            stats.set(data[i].name, obj);
          }
          // 将报警信息转换成具体描述
          const title = this.getAlarmInfo(data[i]);
          this.messages.push({
            title: title,
            roomName: data[i].room.nick_name,
            time: data[i].alarm_update_time,
            id: data[i].id
          });
        }
        // 将报警信息分组
        this.groups = this.createGroups(this.messages);
        // 将统计数据数据转换成图表能读取的格式
        stats.forEach(item => {
          this.chartData.push({
            value: item.count,
            name: item.name,
            itemStyle: {
              color: item.color
            }
          });
        });
        this.group = this.groups[0];
        this.index = 1;
        this.timer = setInterval(() => {
          if (this.index > this.groups.length - 1) {
            this.index = 0;
          }
          this.group = this.groups[this.index];
          this.index++;
        }, 10000);
      })
      .catch(err => {
        this.empty = true;
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
        // 只有在接收到数据时才设置图表
        if (!this.empty) {
          this.$nextTick(() => {
            if (this.chart === null) {
              // 初始化图表 DOM 元素
              this.chart = echarts.init(document.getElementById("police-chart"));
            }
            this.setChart(this.chartData);
          });
        }
      });
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeChart);
  },
}
</script>

<template>
  <div
    id="police-current"
    class="police-current">
    <!-- 加载样式 -->
    <Spin class="loading" v-if="loading">
      <div class="loading-container">
        <Icon class="demo-spin-icon-load" type="ios-loading" size=18></Icon>
        <div class="loading-text">加载中...</div>
      </div>
    </Spin>
    <!-- 报警信息数据 -->
    <div class="empty" v-else-if="empty">
      <img class="empty-icon" src="../../assets/security.png" />
      <div class="empty-text">暂无传感器报警，您的园区很安全</div>
    </div>
    <div class="content" v-else>
      <div id="police-chart" class="chart"></div>
      <transition-group class="message" name="message-item" tag="div">
        <div
          class="message-item"
          :class="{ 'message-item-border-bottom': index === 3 }"
          v-for="(item, index) in group"
          :key="item.id">
          <div class="message-item-title">
            <span class="message-item-marker"></span>
            <span>{{ item.title }}</span>
          </div>
          <div class="message-item-content">
            <div class="message-item-name"><span>{{ item.roomName }}</span></div>
            <div class="message-item-time"><span>{{ item.time }}</span></div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<style scoped>
.police-current {
  position: relative;
  width: 100%;
  height: 80%;
  padding-left: 1vw;
  padding-right: 1vw;
  padding-bottom: 1vw;
}

.loading {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-container {
  display: flex;
  align-items: center;
}

.loading-text {
  padding-left: 0.2vw;
  font-size: 0.6vw;
}

.empty {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-icon {
  width: 1vw;
  height: 1vw;
}

.empty-text {
  padding-left: 0.2vw;
  color: #808695;
  font-size: 0.6vw;
}

.content {
  width: 100%;
  height: 100%;
  display: flex;
}

.chart {
  height: 100%;
  width: 35%;
}

.message {
  position: relative;
  height: 100%;
  width: 65%;
  overflow: hidden;
}

.message-item {
  box-sizing: border-box;
  width: 100%;
  height: 25%;
  border-bottom: solid 0.1vw #003f4d;
  transition-property: all;
  transition-duration: 1.2s;
  transition-timing-function: ease;
  overflow: hidden;
}

.message-item-leave {
  height: 25%;
  border-bottom-width: 0.1vw;
}

.message-item-leave-to {
  height: 0;
  border-bottom-width: 0;
}

.message-item-border-bottom {
  border-bottom: solid 0.1vw rgba(0, 40, 69, 0);
}

.message-item-title {
  width: 100%;
  height: 50%;
  display: flex;
  align-items: center;
  font-size: 0.65vw;
}

.message-item-marker {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: #0FA048;
  margin-right: 10px;
  margin-top: -4px;
}

.message-item-content {
  width: 100%;
  height: 50%;
  display: flex;
}

.message-item-name {
  width: 55%;
  height: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  flex-flow: row;
  color: #a7a7a7;
  font-size: 0.4vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-item-time {
  width: 45%;
  height: 100%;
  text-align: right;
  display: flex;
  align-items: center;
  flex-flow: row-reverse;
  color: #a7a7a7;
  font-size: 0.4vw;
}
</style>
